<template>
  <div class="forgot-password-page d-flex flex-column min-vh-100">
    <div class="container flex-grow-1 d-flex justify-content-center align-items-center">
      <div class="col-md-4">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4 text-center">
            <h3 class="fw-bold mb-4">Forgot Password</h3>

            <div class="text-start mb-3">
              <label for="email" class="form-label">Email Address<span class="text-danger">*</span></label>
              <input
              class="form-control"
                type="email"
                v-model="email"
                id="email"
                placeholder="Enter your registered email"
              />
              <div v-if="emailError" class="d-flex align-items-center text-danger small mt-1">
                <i class="fas fa-exclamation-triangle me-1"></i>
                <span>{{ emailError }}</span>
              </div>
              <div v-if="apiError" class="d-flex align-items-center text-danger small mt-1">
                <i class="fas fa-exclamation-triangle me-1"></i>
                <span>{{ apiError }}</span>
              </div>
            </div>

            <argon-button @click="submitForm" class="btn btn-success btn-lg w-100">Continue</argon-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer text-center py-3">
      <small class="text-muted">
        © PT Anugrah Multi Remittance 2025 |
        <a href="#" class="text-decoration-none text-muted">Terms & Conditions</a> |
        <a href="#" class="text-decoration-none text-muted">Privacy Policy</a>
      </small>
    </footer>
  </div>
  <Loading :isLoading="isLoading" />
</template>

<script>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import ArgonButton from "@/components/ArgonButton";
import { buildFormData } from "../../utils/param-builder";
import { forgotPassword } from "../../api/auth";
import Loading from "@/components/Loading";

export default {
  components: {
    ArgonButton,
    Loading
  },
  data() {
    return {
      email: "",
      isLoading: false,
      emailError: "",
      apiError: ""
    };
  },
  methods: {
    async submitForm() {
      // Clear previous errors
      this.emailError = "";
      this.apiError = "";

      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      const body = {
        email: this.email
      };

      try {
        const formData = buildFormData(body);
        const response = await forgotPassword(formData);
        if (response.message === "Reset token sent to email") {
          this.$store.commit("auth/setEmail", this.email);
          this.$router.push({ name: "ForgotPasswordNotify" });
        } else {
          this.apiError = response.message || "Forgot Password failed";
        }
      } catch (err) {
        console.error("API Error:", err.response?.data?.message);
        this.apiError = err.response?.data?.message || "An error occurred. Please try again.";
      }
      this.isLoading = false;
    },
    validate() {
      if (!this.email) {
        this.emailError = "Email is required";
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.emailError = "Please enter a valid email address";
        return false;
      }

      return true;
    },
  },
  setup() {
    const store = useStore();
    const body = document.getElementsByTagName("body")[0];

    onBeforeMount(() => {
      store.state.hideConfigButton = true;
      store.state.showNavbar = false;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onBeforeUnmount(() => {
      store.state.hideConfigButton = false;
      store.state.showNavbar = true;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });
  },
};
</script>

<style scoped>
.forgot-password-page {
  background-color: #F4F6F6;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer {
  background-color: #F4F6F6;
  width: 100%;
}

.card {
  border-radius: 0.5rem;
}

.text-success {
  color: #37a269 !important;
}

input.form-control {
  padding: 0.6rem 0.75rem;
}

.input-group-text {
  cursor: pointer;
}
</style>
